<template>
    <v-col no-gutters class="py-1">
        <p
            class="mb-1 tw-font-bold"
            :style="{
                color: studio.webAppFontColor,
            }"
        >
            {{ title }}
        </p>
        <p>
            {{ content }}
        </p>
    </v-col>
</template>
<script>
import { mapGetters } from 'vuex'
import { STUDIO_MODULE_NAME } from '@/store/moduleNames'
export default {
    props: ['title', 'content'],
    computed: {
        ...mapGetters({
            studio: `${STUDIO_MODULE_NAME}/getStudio`,
        }),
    },
}
</script>
